import type { ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';

export default function RealEstateInsightCard({ label, description, icon, active, onClick, ariaLabel, expanded }: {
  label: string; description: string; icon: ReactNode; active: boolean; onClick: () => void; ariaLabel: string;
  expanded?: boolean;
}) {
  return <button type="button" onClick={onClick} aria-label={ariaLabel} aria-pressed={active} aria-expanded={expanded} title={label}
    className={`group flex h-10 w-10 shrink-0 items-center rounded-lg border text-left transition-all duration-200
      focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-200/70
      xl:min-h-[94px] xl:h-auto xl:w-full xl:gap-3 xl:rounded-2xl xl:px-3 xl:py-4
      ${active ? 'border-[#8bd3e0]/45 bg-[#17333c]/70 text-[#b9e5ed] shadow-[0_0_24px_rgba(82,163,181,0.07)]'
        : 'border-white/[0.06] bg-white/[0.025] text-white/65 hover:border-white/15 hover:bg-white/[0.055]'}`}>
    <span className={`flex h-10 w-10 shrink-0 items-center justify-center xl:h-14 xl:w-14 xl:rounded-xl xl:border
      ${active ? 'xl:border-[#8bd3e0]/15 xl:bg-[#8bd3e0]/[0.06]' : 'xl:border-white/5 xl:bg-white/[0.035]'} [&>svg]:h-5 [&>svg]:w-5 xl:[&>svg]:h-7 xl:[&>svg]:w-7`}>
      {icon}
    </span>
    <span className="hidden min-w-0 flex-1 xl:block">
      <span className={`block text-[14px] font-medium leading-5 ${active ? 'text-white' : 'text-white/90'}`}>{label}</span>
      <span className="mt-1 block text-[12px] leading-5 text-slate-300/65">{description}</span>
    </span>
    <ChevronRight size={17} className={`hidden shrink-0 transition-transform xl:block ${expanded ? 'rotate-90' : ''} ${active ? 'text-[#a8dce6]' : 'text-white/25 group-hover:text-white/50'}`} aria-hidden="true" />
  </button>;
}
